angular.module('bookingApp').filter('filterUniqueMaxCheck', ['$filter', function(){
    var uniqueMaxFilter = function(input, maxUniquenessReached){
        var hasReachedUniqueMax = false;
        angular.forEach(maxUniquenessReached, function(uniquenessReached){
            if(uniquenessReached.roomId === input.bookable.id && uniquenessReached.rateId === input.rate.id){
                hasReachedUniqueMax = true;
            }
        });
        return hasReachedUniqueMax;
    };
    return uniqueMaxFilter;
}]);